import type { VoidFunctionComponent } from 'react';

import Details from '../../../../shared/vulns/Drawer/Details';
import type { SelectedVuln } from '../../../../../../shared/organizationPackages/response';

import { getSelectedVulnDetails } from './utils';

type Props = { isLoading: boolean; selectedVuln?: SelectedVuln };

/**
 * Container component for the VulnerabilityDrawerDetails
 */
const PackageVulnerabilityDrawerDetails: VoidFunctionComponent<Props> = ({ isLoading, selectedVuln }) => {
  const selectedVulnDetails = getSelectedVulnDetails(selectedVuln);

  return (
    <Details
      isLoading={isLoading}
      selectedVulnDetails={selectedVulnDetails}
    />
  );
};

export default PackageVulnerabilityDrawerDetails;
